import React, { Suspense, useMemo } from 'react';
import { OrderTypeScreen } from './screens/OrderTypeScreen';
import { presetStatus, screenType } from './constants';
import { usePreset } from './preset.context';
import { Portal } from '../Portal';

const screenViews = {
    [screenType.ORDER_TYPE]: OrderTypeScreen,
    
    [screenType.DELIVERY_ADDRESS]: React.lazy(() => import(/* webpackPrefetch: true */ './screens/DeliveryAddressScreen')),
    [screenType.UBER_DELIVERY_ADDRESS]: React.lazy(() => import(/* webpackPrefetch: true */ './screens/UberDeliveryAddressScreen')),
    [screenType.DOORDASH_DELIVERY_ADDRESS]: React.lazy(() => import(/* webpackPrefetch: true */ './screens/DoorDashDeliveryAddressScreen')),

    [screenType.SCHEDULE_TIME]: React.lazy(() => import(/* webpackPrefetch: true */ './screens/ScheduleScreen')),
    [screenType.DELIVERY_SCHEDULE_TIME]: React.lazy(() => import(/* webpackPrefetch: true */ './screens/DeliveryScheduleScreen')),
    [screenType.UBER_DELIVERY_SCHEDULE_TIME]: React.lazy(() => import(/* webpackPrefetch: true */ './screens/DeliveryScheduleScreen')),
    [screenType.DOORDASH_DELIVERY_SCHEDULE_TIME]: React.lazy(() => import(/* webpackPrefetch: true */ './screens/DeliveryScheduleScreen')),
};

export const PresetModal = () => {
    const { currentScreen, status } = usePreset();

    const View = useMemo(() => screenViews[currentScreen], [currentScreen]);
    
    const completed = status === presetStatus.COMPLETED;

    if (completed) {
        return null;
    }
    
    return (
        <Portal>
            <div className="modal fade show" tabIndex="-1" role="dialog">
                <div className="modal-dialog modal-dialog-centered" role="document">
                    <Suspense fallback={<span className="font-weight-bold">Loading...</span>}>
                        <View />
                    </Suspense>
                </div>
            </div>
        </Portal>
    );
};
